import PropTypes from 'prop-types';

import { useState } from 'react';

import { Typography, Button, Modal, Input } from 'antd';

const { Text } = Typography;
const { TextArea } = Input;

const CancelModal = ({ type, isOpen, onOk, onCancel, loading, content }) => {
  const [reason, setReason] = useState('');

  const handleChange = (e) => {
    setReason(e.target.value?.trim());
  };

  const handleCancel = () => {
    onOk(reason);
  };

  return (
    <Modal
      footer={[
        <Button
          key="cancel"
          danger
          disabled={!reason || loading}
          loading={loading}
          onClick={handleCancel}
          type="primary"
        >
          Cancel {type}
        </Button>
      ]}
      onCancel={onCancel}
      open={isOpen}
      title={`Cancel ${type}`}
    >
      {content && <div className="mb-10">{content}</div>}
      <Text className="required-after fw-500">Please mention the reason for cancellation</Text>
      <TextArea className="mt-10" onChange={handleChange} rows={4} />
    </Modal>
  );
};

CancelModal.defaultProps = {
  type: '',
  isOpen: false,
  onOk: () => { },
  onCancel: () => { },
  loading: false,
  content: null
};

CancelModal.propTypes = {
  type: PropTypes.string,
  isOpen: PropTypes.bool,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  loading: PropTypes.bool,
  content: PropTypes.node
};

export default CancelModal;
